export enum AwardCategory {
  MDS = 'MDS',
  FMDS = 'FMDS',
}
